import { createAction, props } from '@ngrx/store';
import {
	FilterSearchRequest,
	BaseSearchColumnFilterModel,
	NdcDestinationHistoryTransactionRecordsBatchModel,
	RebateGroupAggregatorNdcHistoryTransactionModel,
	SearchRequest,
	SearchResponse
} from '@twrx-api-models';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum NdcDestinationHistoryActions {
	LoadNdcDestinationHistoryTransactions = '[Ndc Destination History] LoadTransactions',
	NdcDestinationHistoryTransactionsLoaded = '[Ndc Destination History] TransactionsLoaded',

	LoadNdcDestinationHistoryTransactionRecords = '[Ndc Destination History] LoadTransactionRecords',
	NdcDestinationHistoryTransactionRecordsLoaded = '[Ndc Destination History] TransactionRecordsLoaded',

	BulkRollbackNdcDestinationHistoryTransactions = '[Ndc Destination History] BulkRollbackTransactions',
	BulkRollbackNdcDestinationHistoryTransactionsByFilter = '[Ndc Destination History] BulkRollbackTransactionsByFilter',
	NdcDestinationHistoryTransactionsBulkRolledBack = '[Ndc Destination History] TransactionsBulkRolledBack',

	StartNdcDestinationHistoryDetailsFileGeneration = '[Ndc Destination History] StartDetailsFileGeneration',
	NdcDestinationHistoryDetailsFileGenerationStarted = '[Ndc Destination History] DetailsFileGenerationStarted',

	ErrorOccurred = '[Ndc Destination History] ErrorOccurred'
}

export const loadNdcDestinationHistoryTransactions = createAction(
	NdcDestinationHistoryActions.LoadNdcDestinationHistoryTransactions,
	props<
		ActionRequestPayload<FilterSearchRequest<BaseSearchColumnFilterModel>>
	>()
);

export const ndcDestinationHistoryTransactionsLoaded = createAction(
	NdcDestinationHistoryActions.NdcDestinationHistoryTransactionsLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<RebateGroupAggregatorNdcHistoryTransactionModel>
		>
	>()
);

export const loadNdcDestinationHistoryTransactionRecords = createAction(
	NdcDestinationHistoryActions.LoadNdcDestinationHistoryTransactionRecords,
	props<ActionRequestPayload<SearchRequest> & { transactionId: number }>()
);

export const ndcDestinationHistoryTransactionRecordsLoaded = createAction(
	NdcDestinationHistoryActions.NdcDestinationHistoryTransactionRecordsLoaded,
	props<
		ActionResponsePayload<NdcDestinationHistoryTransactionRecordsBatchModel>
	>()
);

export const bulkRollbackNdcDestinationHistoryTransactions = createAction(
	NdcDestinationHistoryActions.BulkRollbackNdcDestinationHistoryTransactions,
	props<ActionRequestPayload<number[]>>()
);

export const bulkRollbackNdcDestinationHistoryTransactionsByFilter =
	createAction(
		NdcDestinationHistoryActions.BulkRollbackNdcDestinationHistoryTransactionsByFilter,
		props<
			ActionRequestPayload<
				FilterSearchRequest<BaseSearchColumnFilterModel>
			>
		>()
	);

export const ndcDestinationHistoryTransactionsBulkRolledBack = createAction(
	NdcDestinationHistoryActions.NdcDestinationHistoryTransactionsBulkRolledBack
);

export const startNdcDestinationHistoryDetailsFileGeneration = createAction(
	NdcDestinationHistoryActions.StartNdcDestinationHistoryDetailsFileGeneration,
	props<
		ActionRequestPayload<FilterSearchRequest<BaseSearchColumnFilterModel>>
	>()
);

export const ndcDestinationHistoryDetailsFileGenerationStarted = createAction(
	NdcDestinationHistoryActions.NdcDestinationHistoryDetailsFileGenerationStarted
);

export const errorOccurred = createAction(
	NdcDestinationHistoryActions.ErrorOccurred
);
